import { motion } from "framer-motion";
import { AideMarkdownView } from "@/components/aide/AideMarkdownView";
import type { LegalDocument } from "@/content/legal";

// Shared "letterhead" treatment for the three static legal documents (mentions
// légales, politique de confidentialité, CGU). The reference-chip + serif title
// + hairline double rule is the one signature device reused across all three —
// everything below it stays in the app's plain reading style (AideMarkdownView).
export function LegalDocumentCard({ doc }: { doc: LegalDocument }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      className="bg-card border border-border rounded-lg px-6 py-7 sm:px-10 sm:py-9"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1.5 mb-5">
        <span className="inline-flex items-center rounded-full border border-brand-gold-dark/30 bg-brand-gold-dark/[0.06] px-2.5 py-0.5 text-[10.5px] font-medium uppercase tracking-wide text-brand-gold-dark">
          {doc.reference}
        </span>
        {doc.lastUpdated && (
          <span className="text-[11px] text-subtle">Dernière mise à jour : {doc.lastUpdated}</span>
        )}
      </div>

      <h1
        className="mb-1 text-[26px] sm:text-[30px] font-medium leading-tight text-foreground"
        style={{ fontFamily: "var(--font-serif)" }}
      >
        {doc.title}
      </h1>
      <p className="text-[12px] text-subtle mb-6">Le Prestigieux</p>

      <div
        className="mb-7 h-px w-full"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to right, var(--color-brand-gold-dark) 0 6px, transparent 6px 10px)",
          opacity: 0.4,
        }}
      />

      <AideMarkdownView content={doc.content} className="max-w-[70ch]" />
    </motion.article>
  );
}
